import React from 'react';
import { Icons } from '../icons';

// <Icon name="dashboard" size={20} className="..." />
// Renders the Airaa Bold SVG by name with fill="currentColor" so CSS controls colour.
const Icon = ({ name, size = 20, className, style }) => {
  const Component = Icons[name];
  if (!Component) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon "${name}" not found.`);
    }
    return null;
  }
  return <Component size={size} className={className} style={style} />;
};

export default Icon;
